import React from 'react';
import { eventGridLayoutPADefault, eventGridLayoutFFDefault, eventGridLayoutGEDefault, GridLayouts } from '../interfaces/IGridSettings';
import { accordionVisible, dataGridColumnVisible, documentGridColumnVisible } from '../interfaces/IFields';

interface AppSettingsContextType {
	// Define your context properties here
	isDarkTheme: boolean;
	setIsDarkTheme: React.Dispatch<React.SetStateAction<boolean>>;
	accordionState: { [key: string]: boolean };
	setAccordionState: React.Dispatch<React.SetStateAction<{ [key: string]: boolean }>>;
	documentGridColumnState: { [key: string]: boolean };
	setDocumentGridColumnState: React.Dispatch<React.SetStateAction<{ [key: string]: boolean }>>;
	dataGridColumnState: { [key: string]: boolean };
	setDataGridColumnState: React.Dispatch<React.SetStateAction<{ [key: string]: boolean }>>;
	eventGridLayout: GridLayouts;
	setEventGridLayout: React.Dispatch<React.SetStateAction<GridLayouts>>;
	showToDateExpired: boolean;
	setShowToDateExpired: React.Dispatch<React.SetStateAction<boolean>>;
}

const AppSettingsContext = React.createContext<AppSettingsContextType>({
	// Set default values for your context properties
	isDarkTheme: false,
	setIsDarkTheme : () => {},
	accordionState: accordionVisible,
	setAccordionState: () => {},
	documentGridColumnState: documentGridColumnVisible,
	setDocumentGridColumnState: () => {},
	dataGridColumnState: dataGridColumnVisible,
	setDataGridColumnState: () => {},
	eventGridLayout: {
		Generell: eventGridLayoutGEDefault,
		Fellesfeil: eventGridLayoutFFDefault,
		Planlagt: eventGridLayoutPADefault
	},
	setEventGridLayout: () => {},
	showToDateExpired: true,
	setShowToDateExpired: () => {}
});

export default AppSettingsContext;